// @ts-nocheck
import {Suspense, useEffect, useMemo, useState} from "react";
import {BaseTabs, GameCarouselRow, SectionHeader} from "@/components";
import ImprovedConditionalPaymentProfileCard from "../../../../../components/ImprovedConditionalPaymentProfileCard";
import LoadingLogo from "../../../../../components/LoadingLogo/index";
import {useWebSocket} from "../../../../../components/UseWebSocket/index";
import {useMiniGames} from "../../../../../store/useMiniGames";
import {PromoBanners} from "../../../../public/Home/components/PromoBanners";
import CasinoGameCard from "./CasinoGameCard";
import {staticData} from "./staticData";

const PAGE_SIZE = 12;

const CATEGORY_LABELS: Record<string, string> = {
  Roulette: "Ruleta",
  "Black Jack": "Black Jack",
  Baccarat: "Baccarat",
  Sicbo: "Sic Bo",
  OneBJ: "One Blackjack",
  "Dragon Tiger": "Dragon Tiger",
  CONTEST: "Torneos",
  ABH: "ABH",
  Football: "Fútbol",
  Chroma: "Chroma",
};

const CasinoList = () => {
  const getMiniGames = useMiniGames(state => state.getMiniGames);
  const loading = useMiniGames(state => state.loading);
  const allGames = useMiniGames(state => state.filteredList);
  const {tableData} = useWebSocket(allGames);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);

  useEffect(() => {
    getMiniGames(null, "live games");
  }, [getMiniGames]);

  useEffect(() => {
    setVisibleCount(PAGE_SIZE);
  }, [selectedCategory]);

  const allCategories = useMemo(() => {
    return Object.entries(staticData)
      .map(([key, value]) => {
        const rawIds = Array.isArray(value[0]) ? value.flat() : value;
        const games = allGames.filter(game =>
          rawIds.some(id => String(id) === String(game.id))
        );
        return {key, label: CATEGORY_LABELS[key] ?? key, games};
      })
      .filter(c => c.games.length > 0);
  }, [allGames]);

  const visibleCategories = useMemo(
    () => selectedCategory === "All" ? allCategories : allCategories.filter(c => c.key === selectedCategory),
    [allCategories, selectedCategory]
  );

  const tabItems = useMemo(
    () => [{key: "All", label: "Todos"}, ...allCategories.map(c => ({key: c.key, label: c.label}))],
    [allCategories]
  );

  const visibleGames = allGames.slice(0, visibleCount);
  const hasMore = visibleCount < allGames.length;

  return (
    <>
      <ImprovedConditionalPaymentProfileCard />
      <PromoBanners />
      <div style={{padding: "var(--space-5)"}}>
        {loading ? (
          <LoadingLogo />
        ) : (
          <div className="flex flex-col gap-10">
            <div className="flex flex-col gap-3">
              <h2 className="m-0 font-extrabold text-[var(--color-text)] text-[clamp(1.125rem,2vw,1.375rem)] tracking-tight leading-tight">
                Tus categorías de casino en vivo favoritas
              </h2>
              <BaseTabs
                items={tabItems}
                activeKey={selectedCategory}
                onChange={setSelectedCategory}
              />
            </div>

            {/* ── Carruseles por categoría ── */}
            {visibleCategories.map(({key, label, games}) => (
              <GameCarouselRow
                key={key}
                title={label}
                subtitle={`${games.length} mesas en vivo`}
              >
                {games.map(game => {
                  const table = tableData.find(t => t.tableId === game.id) || {};
                  return (
                    <Suspense
                      key={game.id}
                      fallback={
                        <div className="w-[240px] max-[640px]:w-[110px] flex-shrink-0" style={{height: 180, borderRadius: 12, background: "var(--color-surface)"}} />
                      }
                    >
                      <div className="w-[240px] max-[640px]:w-[110px] flex-shrink-0">
                        <CasinoGameCard
                          name={game.name}
                          provider={game.provider}
                          icon={game.icon}
                          gameId={game.id}
                          isFav={game.isFav}
                          tableInfo={table}
                        />
                      </div>
                    </Suspense>
                  );
                })}
              </GameCarouselRow>
            ))}

            {/* ── Todos los juegos — grid con paginación ── */}
            {selectedCategory === "All" && allGames.length > 0 && (
              <section>
                <SectionHeader
                  title="Todos los juegos"
                  subtitle={`${allGames.length} mesas disponibles`}
                  tone="primary"
                />
                <div
                  className="grid gap-3 grid-cols-3 min-[640px]:grid-cols-4 min-[768px]:grid-cols-5 min-[1200px]:grid-cols-6"
                >
                  {visibleGames.map(game => {
                    const table = tableData.find(t => t.tableId === game.id) || {};
                    return (
                      <Suspense
                        key={game.id}
                        fallback={
                          <div style={{height: 150, borderRadius: 12, background: "var(--color-surface)"}} />
                        }
                      >
                        <CasinoGameCard
                          name={game.name}
                          provider={game.provider}
                          icon={game.icon}
                          gameId={game.id}
                          isFav={game.isFav}
                          tableInfo={table}
                        />
                      </Suspense>
                    );
                  })}
                </div>

                {hasMore && (
                  <div className="flex flex-col items-center gap-2 mt-8 mb-4">
                    <button
                      type="button"
                      className="btn-load-more"
                      onClick={() => setVisibleCount(c => c + PAGE_SIZE)}
                    >
                      Cargar más juegos
                    </button>
                    <span className="text-sm" style={{color: "var(--color-text-tertiary)"}}>
                      Mostrando {visibleCount} de {allGames.length} juegos
                    </span>
                  </div>
                )}
              </section>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default CasinoList;
